export enum REQUEST_STEPS {
  SELECTION = 'selection',
  MECHANICAL_OPTIONS = 'mechanical-options',
  LEASING_OPTIONS = 'lease-details',
  REVIEW = 'review',
  SUBMIT = 'submit',
}

export const TRIN_USER = 'trin_user';
